import { useWallet } from '@solana/wallet-adapter-react';
import { Skeleton } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { Button } from '../../../common/Button';
import { useStack } from '../../../hooks/useStaking';
import NftCard from '../NftCard';
import {
  ClaimButton,
  CollectionMain,
  CollectionRoot,
  ConnectInfo,
  GridContainer,
  TabButtons,
} from './styles';

const Collections = () => {
  const { animals, stakedAnimals, claimAllStakingRewards, status } = useStack();
  const [active, setActive] = useState(1);
  const { connected, wallet } = useWallet();
  const [animalsReady, setAnimalsReady] = useState(false);
  const [stakedAnimalsReady, setStakedAnimalsReady] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      //@ts-ignore
      const isActive = JSON.parse(localStorage.getItem('active'));
      if (isActive) {
        setActive(Number(isActive));
      } else {
        localStorage.setItem('active', active.toString());
      }
    }
  }, [typeof window, active]);

  const handleActiveTab = (key: number) => {
    setActive(key);
    localStorage.setItem('active', key.toString());
  };

  const handleClaimAll = useCallback(async () => {
    await claimAllStakingRewards();
  }, [stakedAnimals]);

  // loading state and check has animals
  useEffect(() => {
    setAnimalsReady(false);
    if (animals.length) {
      setAnimalsReady(false);
      return;
    }
    if (!animals.length && !animalsReady) {
      const timeoutID = window.setTimeout(() => {
        setAnimalsReady(true);
      }, 1000);
      return () => window.clearTimeout(timeoutID);
    }
  }, [animals.length]);

  useEffect(() => {
    if (animalsReady && animals.length) {
      setAnimalsReady(false);
    }
  }, [animalsReady, animals]);

  // loading state and check has staked animals
  useEffect(() => {
    setStakedAnimalsReady(false);
    if (stakedAnimals.length) {
      setStakedAnimalsReady(false);
      return;
    }
    if (!stakedAnimals.length && !stakedAnimalsReady) {
      const timeoutID = window.setTimeout(() => {
        setStakedAnimalsReady(true);
      }, 1000);
      return () => window.clearTimeout(timeoutID);
    }
  }, [stakedAnimals.length]);

  useEffect(() => {
    if (stakedAnimalsReady && stakedAnimals.length) {
      setStakedAnimalsReady(false);
    }
  }, [stakedAnimalsReady, stakedAnimals]);

  return (
    <>
      {connected && wallet?.adapter.publicKey ? (
        <CollectionRoot>
          {/* Nft collection Tab */}
          <TabButtons>
            <Button
              color={active === 1 ? 'primary' : ''}
              onClick={() => handleActiveTab(1)}
            >
              My Dolphins
            </Button>
            <Button
              color={active === 2 ? 'primary' : ''}
              onClick={() => handleActiveTab(2)}
            >
              Staked Dolphins
            </Button>
          </TabButtons>

          <CollectionMain>
            <div
              style={{
                display: active === 1 ? 'flex' : 'none',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '50vh',
                marginTop: '-40px',
              }}
            >
              {animalsReady && !animals.length && status.animals.loadingEnd ? (
                <>
                  {stakedAnimals.length ? (
                    <h2 className='info'>
                      All Dolphins are Staked Get some More?{' '}
                      <a
                        href='https://magiceden.io/marketplace/malibu_dolphin_mixer'
                        target='_blank'
                      >
                        Click Here
                      </a>
                    </h2>
                  ) : (
                    <h2 className='info'>
                      You currently have no Dolphins.
                      <a
                        href='https://magiceden.io/marketplace/malibu_dolphin_mixer'
                        target='_blank'
                      >
                        Buy Now
                      </a>
                    </h2>
                  )}
                </>
              ) : (
                <GridContainer>
                  {status.animals.loading
                    ? [...Array(3)].map((arr, i) => (
                        <Skeleton.Avatar
                          key={i}
                          active
                          shape='square'
                          size={300}
                        />
                      ))
                    : animals?.map((dolphin) => (
                        <NftCard
                          key={dolphin.uriData.image}
                          isStaked={false}
                          token={dolphin}
                        />
                      ))}
                </GridContainer>
              )}
            </div>

            {/* staked NFTS */}
            <div
              style={{
                display: active === 2 ? 'flex' : 'none',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                minHeight: '50vh',
                marginTop: '-40px',
              }}
            >
              {stakedAnimalsReady &&
              !stakedAnimals.length &&
              status.stakedAnimals.loadingEnd ? (
                <>
                  {!stakedAnimals.length && (
                    <h2 className='info'>
                      No Dolphins are Staked... yet {';)'}
                    </h2>
                  )}
                </>
              ) : (
                <>
                  <GridContainer>
                    {stakedAnimals.length
                      ? stakedAnimals?.map((dolphin) => (
                          <NftCard
                            key={dolphin.uriData.image}
                            isStaked={true}
                            token={dolphin}
                          />
                        ))
                      : status.stakedAnimals.loading
                      ? [...Array(3)].map((arr, i) => (
                          <Skeleton.Avatar
                            key={i}
                            active
                            shape='square'
                            size={300}
                          />
                        ))
                      : ''}
                  </GridContainer>
                  {!stakedAnimals.length && !status.stakedAnimals.loading ? (
                    <h2 className='info'>
                      No Dolphins are Staked... yet {`;)`}
                    </h2>
                  ) : (
                    ''
                  )}
                  {stakedAnimals.length ? (
                    <ClaimButton onClick={handleClaimAll}>
                      Claim All Rewards
                    </ClaimButton>
                  ) : (
                    ''
                  )}
                </>
              )}
            </div>
          </CollectionMain>
        </CollectionRoot>
      ) : (
        <ConnectInfo>
          <h2>Please Connect your wallet</h2>
        </ConnectInfo>
      )}
    </>
  );
};

export default Collections;
